import { Card, CardBody, Typography } from "@material-tailwind/react";

import AuthService from "../../../services/authService";

function CreditCard({ accountNumber }: { accountNumber: string | undefined }) {
  const user = AuthService.user?.data;
  return (
    <div>
      <Card placeholder={undefined} className=" shadow-sm">
        <CardBody placeholder={undefined}>
          <Card placeholder={undefined} className=" shadow-sm">
            <div className="bg-[#1D1F2C] p-4 rounded-xl relative overflow-hidden h-full ">
              <span className="absolute top-2 right-2 w-3 h-3 rounded-full bg-green-500"></span>
              <span className="absolute top-5 right-28 w-4 h-4 rounded-full bg-purple-500"></span>
              <span className="absolute top-8 right-20 w-6 h-6 rounded-full border border-yellow-500"></span>
              <span className="absolute top-20 -right-4 w-10 h-10 rounded-full border-4 border-green-500"></span>
              <span className="absolute top-8 right-8 w-4 h-4 rounded-full border-4 border-red-500"></span>
              <Card
                placeholder={undefined}
                className=" bg-transparent lg:top-32 rounded-xl relative z-10 shadow-xl"
              >
                <CardBody
                  placeholder={undefined}
                  className="bg-transparent p-4 rounded-xl bottom-1 right-2  text-gray-200"
                >
                  <Typography
                    placeholder={undefined}
                    className="text-sm text-gray-400 mt-2"
                  >
                    Account Number
                  </Typography>
                  <Typography
                    placeholder={undefined}
                    className="text-xl font-medium text-white"
                  >
                    {accountNumber ?? "..."}
                  </Typography>
                  <Typography
                    placeholder={undefined}
                    className="text-sm text-gray-400 mt-2"
                  >
                    Account Name
                  </Typography>
                  <Typography
                    placeholder={undefined}
                    className="text-xl font-medium text-white"
                  >
                    {user?.firstName} {user?.lastName}
                  </Typography>
                  <Typography
                    placeholder={undefined}
                    className="text-sm text-gray-400 mt-2"
                  >
                    Bank
                  </Typography>
                  <Typography
                    placeholder={undefined}
                    className="text-xl font-medium text-white mb-32"
                  >
                    Stellas Bank
                  </Typography>
                </CardBody>
              </Card>
            </div>
            <div></div>
          </Card>
          {/* <Typography
            placeholder={undefined}
            className="text-sm text-gray-400 mt-2"
          >
            
          </Typography> */}
          {/* <div className="flex justify-between items-center">
            <Typography
              placeholder={undefined}
              className="text-xl font-semibold text-black "
            >
              N15,309,430
            </Typography>
            <div className="flex">
              <IoIosArrowDropleftCircle color="black" size={30} />
              <IoIosArrowDroprightCircle color="black" size={30} />
            </div>
          </div> */}
        </CardBody>
      </Card>
    </div>
  );
}

export default CreditCard;
